<template>
    <div class="filter-view">
        <div class="back">
            <router-link to="/home">
                <font-awesome-icon icon="home" class="back-icon" />
            </router-link>
        </div>
        <div class="search">
            <font-awesome-icon icon="search" class="search-icon" />
            <input
                :value="value"
                :placeholder="placeholder"
                @input="$emit('input', $event.target.value)"
            />
        </div>
        <div class="slot"><slot /></div>
    </div>
</template>

<script>
export default {
    props: ['value', 'placeholder'],
};
</script>

<style lang="scss">
.filter-view {
    height: 50px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;

    .back {
        box-sizing: border-box;
        width: 50px;
        opacity: 0.5;
        box-shadow: 2px 0 4px 2px rgba(212, 216, 221, 0.43);
        display: flex;
        align-items: center;
        justify-content: center;

        .back-icon {
            width: 25px;
            height: 25px;
            color: #8e919b;
        }
    }

    .search {
        display: flex;
        flex: 1;
        align-items: center;
        padding-left: 20px;
        color: #9ca5b0;

        .search-icon {
            width: 18px;
            height: 18px;
        }

        input {
            font-size: 13px;
            line-height: 18px;
            margin-left: 12px;
            outline: none;
            border: none;
            width: 100%;
            padding-right: 35px;
            text-overflow: ellipsis;
        }
    }

    .slot {
        display: flex;
        align-items: center;
        padding-right: 32px;
    }
}
</style>
